<style scoped>
    .logoHead{
        background:url('@/assets/images/logobg.png') no-repeat;
        background-size: 100% 100%;
    }
    .homeConBg{
        background:url('@/assets/images/homebg.jpg') no-repeat;
        background-size: 100% 100%;
    }
    .firsthref,.apphref{
        cursor: pointer;
    }
    
    .hrefbg a{
        background-color: #694f83;
        color: #c3bec1;
        white-space: nowrap;
    }
    .href1{
        border-left:3px solid #5a2167;
    }
    .href2{
        border-left:3px solid #4e257a;
    }
    .href3{
        border-left:3px solid #664253;
    }
    .qrBg{
         background-color: rgba(81, 55, 104, 0.6); 
        
    }
    .logoimg{
        max-width: 13rem;
    }
    .qr-img{
        max-width: 8rem;
    }
    .notice{
        width: 70%;
    }
    sup {
        top: -1em;
        color: blue;
    }
    .btnbg{
        position: relative;overflow: hidden; /* 关键：隐藏超出部分 */
        color: white;
        border: none;
        text-transform: uppercase;
        cursor: pointer;
        background-size: 300% 300% !important;
        animation: gradientBG 4s ease infinite;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        transition: all 0.3s;
    }
    .btn-gradient {
        background: linear-gradient(45deg, #a013fa, #d89ffc, #b955f9, #8000f8);
        /* background: linear-gradient(45deg, #ff9a9e, #fad0c4, #fbc2eb, #a6c1ee); */
    }
    .firsthref{
        background: linear-gradient(45deg, #3db2fa, #6579f6, #6dbef0,#2540f1 );
    }
    .firsthref2{
        background: linear-gradient(45deg, #510ce3, #140a98, #4f21e7, #7174f8);
        /* background: linear-gradient(45deg, #e3730c, #ffe232, #ff9b0f, #ffc112); */
    }
    .chatBtn{
        /* background: linear-gradient(45deg, #3f9f07, #a2f874, #4bbe10); */
         background: linear-gradient(45deg, #8f3a06, #dab890, #a64d17);
         font-size: xx-small;
    }
    .appDown{
        /* background: linear-gradient(45deg, #3f9f07, #88ed52, #4bbe10); */
        background: linear-gradient(45deg, #348d00, #1b2415, #03eb2d);
        
    }
    .firsthref:hover,.firsthref2:hover,.appDown:hover,.btn-gradient:hover {
        transform: translateY(-3px);
        box-shadow: 0 7px 20px rgba(0, 0, 0, 0.3);
    }
    /* 水波纹基础样式 */
        .btnbg::before,
        .btnbg::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            background: rgba(2, 10, 83, 0.3);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            opacity: 0.6;
            z-index: -1;
        }
        
        /* 第一个波纹动画 */
        .btnbg:hover::before {
            animation: ripple 1.5s infinite linear;
        }
        
        /* 第二个波纹动画 - 延迟0.5秒 */
        .btnbg:hover::after {
            animation: ripple 1.5s infinite 0.5s linear;
        }
        
        /* 波纹动画定义 */
        @keyframes ripple {
            0% {
                width: 0;
                height: 0;
                opacity: 0.7;
            }
            50% {
                opacity: 0.5;
            }
            100% {
                width: 200px;
                height: 200px;
                opacity: 0;
            }
        }
        
        /* 添加第三个波纹效果 - 使用span元素 */
        .ripple-effect {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            background: rgba(2, 10, 83, 0.3);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            opacity: 0.6;
            z-index: -1;
        }
        
        .multi-ripple-btn:hover .ripple-effect {
            animation: ripple 1.5s infinite 1s linear;
        }
    .hover-scale{
        transition: transform .5s cubic-bezier(.25, 1.15, .35, 3.08);
        animation: hover-scale 1s linear infinite alternate;
    }
    @keyframes hover-scale{
        100%{
            transform: scale(1.05);
        }
    }
    @keyframes gradientBG {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }
    @media (max-width: 575px){
        .logoHead{
            background:url('@/assets/images/logoPhoneBg.png') no-repeat;
            background-size: 100% 100%;
        }
        .homeConBg{
            background:url('@/assets/images/homePhoneBg.jpg') no-repeat;
            background-size: 100% 100%;
        }
		.logoimg{
			max-width: 7rem;
		}
        .qr-img{
			max-width: 7rem;
		}
        .notice{
            width: 100%;
        }
    }
    .scale-letter span{
        display: inline-block;
        animation: scale-letter 2s infinite ;
        letter-spacing: .1rem;
        /* animation-direction: alternate; */
    }
    .scale-letter span:nth-child(1) { animation-delay: 0s; }
    .scale-letter span:nth-child(2) { animation-delay: .3s; }
    .scale-letter span:nth-child(3) { animation-delay: .6s; }
    .scale-letter span:nth-child(4) { animation-delay: .9s; }
    @keyframes scale-letter {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.35);
        }
    }
</style>
<template>
    <div class="d-flex flex-column h-100 w-100">
        <!-- 头部导航栏 -->
        <div class="logoHead index-1">
            <div class="container">
                <div class="d-flex justify-content-center">
                    <div class="d-flex flex-column mt-1">
                        <img class="logoimg" src="images/logo.png"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-grow-1 flex-column homeConBg">
            
            <!-- 内容部分 -->
            <div class="flex-grow-1 flex-column d-flex justify-content-center">
                <div class="d-sm-flex d-none flex-column">
                    <div class="d-flex justify-content-center align-items-center px-3">
                        <div class="position-relative d-flex flex-column1 m-2 align-items-center">
                            <img style="max-width:100%" src="@/assets/images/title1.png"/>
                            <a class="position-absolute bottom-10 end-25 btn btnbg chatBtn text-light px-2 py-0 rounded-3 fs-8 small" type="button" @click="goLink(chatUrl.url)">
                                <span class="small scale-letter">
                                    <span>在</span>
                                    <span>线</span>
                                    <span>客</span>
                                    <span>服</span>
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center px-3 mb-4 mb-sm-3" >
                        <div v-if="getNewsList()[0]" class=" d-flex m-2 me-2">
                            <a class="btn fw-bold btnbg firsthref text-light px-3 py-1 rounded-5 fs-5" type="button" @click="goLink(getNewsList()[0].url)" href="javascript:;">优先推荐<sup>{{ getNewsList()[0].status }}</sup></a>
                        </div>
                        <div v-for="(item,i) in getNewsList().slice(1)" :key="item" class=" d-flex m-2 me-1 btnbg btn-gradient rounded-5">
                            <a type="button" @click="goLink(item.url)" href="javascript:;" class="btn fw-bold px-4 text-light">{{item.text}}<sup>{{ item.status }}</sup></a>
                        </div>
                        <div v-for="(item,i) in getOldList()" :key="item" class=" d-flex m-2 me-1 btnbg btn-gradient rounded-5">
                            <a type="button" @click="goLink(item.url)" href="javascript:;" class="btn fw-bold px-4 text-light">{{item.text}}<sup>{{ item.status }}</sup></a>
                        </div>
                    </div>  
                </div>
                <!--手机版-->
                <div class="d-flex d-sm-none flex-column flex-grow-1 justify-content-evenly col">
                    <div class="d-flex justify-content-center align-items-center px-2">
                        <div class="position-relative d-flex flex-column m-sm-3 align-items-center mt-2">
                            <img style="max-width:100%; height: 30%;" src="@/assets/images/title1.png"/>
                            <a class="position-absolute bottom-10 end-18 btn btnbg chatBtn text-light px-1 py-0 rounded-3 fs-8 small" type="button" @click="goLink(chatUrl.url)">
                                <span class="small scale-letter">
                                    <span>在</span>
                                    <span>线</span>
                                    <span>客</span>
                                    <span>服</span>
                                </span>
                            </a>
                        </div>
                    </div>
                    <div v-if="getNewsList()[0]" class="d-flex justify-content-center m-sm-1 align-items-center my-1">
                        <a class="position-relative btn btnbg firsthref text-light py-1 rounded-3 mx-1 px-1 me-1 w-40" type="button" @click="goLink(getNewsList()[0].url)" href="javascript:;">优先推荐&nbsp;&nbsp;<sup class="position-absolute top-20">{{ getNewsList()[0].status }}</sup></a>
                        <!-- <a class="btn btnbg appDown text-light py-1 rounded-3 fs-6" type="button" @click="goLink(chatUrl)">在线客服</a> -->
                        <!-- <a type="button" @click="goLink(getNewsList()[1].url)" href="javascript:;" class="btn btnbg btn-gradient px-1 py-1 mx-1">
                            <span class="text-light">{{getNewsList()[1].text}}</span><sup>{{ getNewsList()[1].status }}</sup>
                        </a> -->
                    </div>
                    <div v-for="(item,i) in getNewsList().slice(1)" :key="item" class=" d-flex justify-content-center m-sm-1 align-items-center my-1">
                        <div class=" d-flex mx-1 me-1 btnbg btn-gradient rounded-3 w-40 align-content-center">
                            <a type="button" @click="goLink(item.url)" href="javascript:;" class="position-relative btn px-1 py-1 w-100">
                                <span class="text-light">{{item.text}}</span><sup class="position-absolute top-20">{{ item.status }}</sup>
                            </a>
                        </div>
                    </div>
                    <!-- <div class="d-flex flex-column justify-content-center align-items-center px-2 mb-sm-1" >
                    </div>   -->
                </div>
                <div class="d-sm-flex d-none flex-column">
                    <div class="d-flex justify-content-center align-items-center px-3">
                        <div class="position-relative d-flex flex-column m-2 align-items-center">
                            <img style="max-width:100%" src="@/assets/images/title2.png"/>
                            <!-- <a class="btn btnbg appDown text-light px-2 py-1 rounded-5 fs-5 px-3 py-1" type="button" @click="goLink(appUrl.url)">{{ appUrl.text }}</a> -->
                            <a class="position-absolute bottom-10 end-24 btn btnbg appDown text-light px-2 py-0 rounded-3 fs-8 small" type="button" @click="goLink(appUrl.url)">
                                <span class="small fw-bold">{{ appUrl.text }}</span>
                            </a>
                        </div>
                    </div> 
                    <div class="d-flex justify-content-center align-items-center px-3 mb-4 mb-sm-3">
                        <div v-if="getPhoneList()[0]" class="d-flex m-2 me-2">
                            <a class="btn fw-bold btnbg firsthref2 text-light px-3 py-1 rounded-5 fs-5 rounded-5" type="button" @click="goLink(getNewsList()[0].url)" href="javascript:;">优先推荐<sup style="color: chartreuse;">{{ getNewsList()[0].status }}</sup></a>
                        </div>
                       <div v-for="(item,i) in getPhoneList().slice(1)" :key="item" class=" d-flex m-2 me-1 btnbg btn-gradient rounded-5">
                            <a type="button" @click="goLink(item.url)" href="javascript:;" class="btn fw-bold px-4 text-light">{{item.text}}<sup>{{ item.status }}</sup></a>
                        </div>
                        <div class=" d-flex m-2">
                            
                        </div>
                    </div>  
                </div>
                <div class="d-flex flex-column flex-grow-1 flex-sm-grow-0 justify-content-evenly col">
                    <div class="d-flex justify-content-center align-items-center px-3">
                        <div class="d-flex flex-column m-sm-2 align-items-center">
                            <img style="max-width:100%" src="@/assets/images/title3.png"/>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-1 ">
                        <div class="qrBg flex-wrap d-sm-flex d-none justify-content-center py-3 px-5 ">
                            <div v-for="(item,i) in urlList" :key="item" class="qr-img px-3 align-items-center flex-column" @click.stop="showDetail(item)" role="button">
                                <vue-qr class="d-flex img-thumbnail rounded hover-scale" :margin="5" :text="createQr(item.url)"></vue-qr>
                                <span class="d-flex flex-column small text-light text-center" style="display: inherit;">{{item.text}}</span>
                            </div>
                        </div>
                        <div class="qrBg flex-wrap d-flex d-sm-none justify-content-center py-sm-2 px-5 ">
                            <div v-for="(item,i) in urlList" :key="item" :class="[i==3?'d-none':'d-flex']" class="qr-img  px-1 align-items-center flex-column col-4" @click.stop="showDetail(item)" role="button">
                                <vue-qr class="d-flex img-thumbnail rounded hover-scale" :margin="0" :text="createQr(item.url)"></vue-qr>
                                <span class="d-flex flex-column small text-light" style="display: inherit;">{{item.text}}</span>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>

            <div class="d-sm-flex d-none justify-content-center bg-black text-light">
                <div class="d-flex px-3 notice">
                    <div class="d-flex flex-column m-2 align-items-center">
                        <img style="width: 20em;" src="@/assets/images/speaker.png"/>
                    </div>
                    <div class="d-flex justify-content-center mb-1">    
                        <span class="d-flex lh-3 small" style="font-family: '黑体','Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 2rem;">
                            {{ this.noticeText }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="d-flex d-sm-none flex-column flex-grow-1 justify-content-center text-light">
                <div class="d-flex notice  flex-grow-1">
                    <div class="d-flex justify-content-center mb-1">
                        <span class="small align-items-center" style="font-family: '黑体','Segoe UI', Tahoma, Geneva, Verdana, sans-serif;word-spacing: -1px;letter-spacing: -0.6px;text-align: justify;">
                            <!-- <i class="bi bi-megaphone-fill mx-2 py-1 text-warning"></i> -->
                            <span class="d-flex px-3 bg-black"> {{ this.noticeText }}</span>
                        </span>
                    </div>
                </div>
            </div>
            
           <!-- copyright -->
            <div class="copyright-area border border-bottom-0">
                <div class="container">
                    <div class="row">
                        <div class="copyright-wrap">
                            <div class="left-copyright ">
                                <p class="d-sm-flex d-none text-light py-2 justify-content-center">{{footCopyRight}}</p>
                                <span class="d-flex d-sm-none text-light small justify-content-center"><span class="small">{{footCopyRight}}</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="scaleQr" class="position-fixed top-0 bottom-0 start-0 end-0 bg-dark bg-opacity-75 d-flex flex-column justify-content-center align-items-center">
            <vue-qr class="d-flex  img-thumbnail rounded" :margin="10" :text="createQr(scaleQr.url)"></vue-qr>
            <a class="d-flex btn fw-bold btnbg btn-gradient text-light px-3 py-1 mt-2 rounded-4 fs-5" type="button" @click.stop="goLink(scaleQr.url)">点击下载</a>
        </div>
    </div>
</template>
<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
export default {
    name: 'HomeView',
	components: {
		vueQr
	},
    data(){
        return {
			 urlList:config.urlList,
			 appUrl:config.appUrl,
			 chatUrl:config.chatUrl,
			 footCopyRight:config.footCopyRight,
             newsList:config.newsList,
             oldList:config.oldList,
             phoneList:config.phoneList,
             sortNewsList:[],
             sortOldList:[],
             sortPhoneList:[],
             scaleQr:null,
             noticeText:config.noticeText,
        }

    },
    computed:{
        
    },
    async mounted(){
        let lastLatencyTime=localStorage.getItem("lastLatencyTime")||0;//获取缓存中的最后一次获取ws延迟检测的时间
        let nowLatencyTime=new Date();//本次获取ws延迟检测的时间
        let ms=nowLatencyTime-new Date(lastLatencyTime);//上次时间到本次时间相隔的毫秒数
        let oldSortNewsList=localStorage.getItem("oldSortNewsList")||[];
        let oldSortOldList=localStorage.getItem("oldSortOldList")||[];
        let oldSortPhoneList=localStorage.getItem("oldSortPhoneList")||[];
        if(Math.floor(ms/1000)>15||oldSortNewsList.length==0||oldSortPhoneList.length==0||oldSortOldList.length==0){//超过1分钟则重新获取
            for(let i of this.newsList){
                this.sortNewsList.push({
                    url: i.url,
                    text: i.text,
                    speed: 9999,
                    status: '测速中'
                });//先放进去再测速，避免一开始不显示
                this.testUrlSpeed(i.url,i.text).then(v=>{
                    let obj=this.sortNewsList.find(s=>s.text==v.text);
                    obj.speed=v.speed;
                    obj.status=v.status;
                    this.sortNewsList.sort((a,b)=>a.speed-b.speed);
                    localStorage.setItem("oldSortNewsList",JSON.stringify(this.sortNewsList));
                });
            }
            //旧版入口测速
            for(let i of this.oldList){
                this.sortOldList.push({
                    url: i.url,
                    text: i.text,
                    speed: 9999,
                    status: '测速中'
                })
                this.testUrlSpeed(i.url,i.text).then(v=>{
                    let obj=this.sortOldList.find(s=>s.text==v.text);
                    obj.speed=v.speed;
                    obj.status=v.status;
                    this.sortOldList.sort((a,b)=>a.speed-b.speed);
                    localStorage.setItem("oldSortOldList",JSON.stringify(this.sortOldList));
                });
            }
            
            for(let i of this.phoneList){
                this.sortPhoneList.push({
                    url: i.url,
                    text: i.text,
                    speed: 9999,
                    status: '测速中'
                })
                this.testUrlSpeed(i.url,i.text).then(v=>{
                    let obj=this.sortPhoneList.find(s=>s.text==v.text);
                    obj.speed=v.speed;
                    obj.status=v.status;
                    this.sortPhoneList.sort((a,b)=>a.speed-b.speed);
                    localStorage.setItem("oldSortPhoneList",JSON.stringify(this.sortPhoneList));
                });
            }
            localStorage.setItem("lastLatencyTime",nowLatencyTime);//设置新的最后检测时间
        }else{
            this.sortNewsList=JSON.parse(oldSortNewsList);
            this.sortOldList=JSON.parse(oldSortOldList);
            this.sortPhoneList=JSON.parse(oldSortPhoneList);
        }
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl)
        })
    },
    methods:{
        getNewsList(){
            if(this.sortNewsList.length==0){
                return this.newsList;
            }else{
                return this.sortNewsList;
            }
        },
        getOldList(){
            if(this.sortOldList.length==0){
                return this.oldList;
            }else{
                return this.sortOldList;
            }
        },
        getPhoneList(){
            if(this.sortPhoneList.length<this.phoneList.length){
                return this.phoneList;
            }else{
                return this.sortPhoneList;
            }
        },
        /**
         * 跳转到客服链接
         */
        toChat(url){
            window.open(url,'_blank');
        },
        goLink(url){
            window.location.href=url;
        },
        goAnchor (selector) {
			document.querySelector(selector).scrollIntoView({
				behavior:"smooth"
			})
		},
		createQr(url){
			var title=new RegExp('Http','i');
			var result=title.test(url)
			if(result!=true){
				url=location.origin+"/#/"+url
				// console.log(url) 
			}
			return url;
		},
        async testUrlSpeed(url,text) {
            return new Promise((resolve) => {
                const startTime = performance.now();
                
                // 创建一个图片对象来测试加载速度（避免CORS问题）
                const img = new Image();
                
                // 设置超时
                const timeout = setTimeout(() => {
                    img.onload = img.onerror = null;
                    resolve({
                        url: url,
                        text: text,
                        speed: 9999,
                        status: '超时'
                    });
                }, 5000);
                
                img.onload = img.onerror = function() {
                    clearTimeout(timeout);
                    const endTime = performance.now();
                    const speed = Math.round(endTime - startTime);
                    resolve({
                        url: url,
                        text: text,
                        speed: speed,
                        status: speed + 'ms'
                    });
                };
                
                // 添加时间戳防止缓存
                img.src = url + '?t=' + new Date().getTime();
            });
        },
        showDetail(qr){
            this.scaleQr=qr;
            document.onclick=(e)=>{
                e.stopPropagation();
                this.scaleQr=null;
            }
        }
    },
}
</script>